





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DrawerTreeView from '@/layouts/core/drawer/DrawerTreeView.vue';
import DrawerList from '@/layouts/core/drawer/DrawerList.vue';
import { namespace } from 'vuex-class';
import { User } from '@/modules/backend/Entities/User';

const AuthModule = namespace('app/auth');

@Component({
  components: {
    'drawer-tree-view': DrawerTreeView,
    'drawer-list': DrawerList,
  }
})
export default class NavigationDrawer extends Vue {
  @Prop({ default: true })
  private readonly show!: boolean;

  @Prop({ default: false })
  private readonly mini!: boolean;

  @Prop({ default: false })
  private readonly mobile!: boolean;

  @AuthModule.Getter('Info')
  private readonly AuthInfo!: User;

  private get hasTreeItems(): boolean {
    return this.AuthInfo?.getCompanies().length > 0;
  }

  private get navigationDrawerWrapperWidth(): number {
    const DEFAULT_WIDTH = 256;
    const MINI_WIDTH = 56;

    if (this.mobile) {
      return DEFAULT_WIDTH;
    }

    if (this.hasTreeItems) {
      return this.mini ? (DEFAULT_WIDTH + MINI_WIDTH) : (DEFAULT_WIDTH + DEFAULT_WIDTH);
    }

    return this.mini ? MINI_WIDTH : DEFAULT_WIDTH;
  }

  private menuStateChangedHandler(newState: boolean): void {
    this.$emit('menu-state-changed', newState);
  }
}
